module.exports = __webpack_public_path__ + "img/login-bgi.4bdd2271.png";